import get from 'lodash.get';

import { PackageService } from '../../services/package-service';
import Global from '../../store/global-selectors';
import { calculateReturnShipmentWeight } from '../../services/return-shipment-weight/calculate-return-shipment-weight';
import { emptyObject, emptyArray } from 'ui-components/default-props/empty';

const calculateNonVoidedFulfillments = (state, fulfillmentsFromSalesOrder) => {
  // this is overly complicated because there are two different values we store in redux
  // depending on where we originate the return from
  // from the shipment grid we are isCreatingReturnsFromShipment and have a defined returnFulfillmentPlanId
  // from order details (!isCreatingReturnsFromShipment and !returnFulfillmentPlanId) we
  // use the fulfillmentPlanId. These values are often the same, but are they always the same?
  const isCreatingReturnsFromShipment = Global.selectOrderDetailsisReturnsFromShipment(state);
  const returnFulfillmentPlanId = Global.selectOrderDetailsShipmentIdForReturns(state);

  if (isCreatingReturnsFromShipment) {
    const existingFulfillments = Global.selectEntitiesFulfillmentPlans(state);
    const existingFulfillment = get(existingFulfillments, `${returnFulfillmentPlanId}`, {});
    const standardPackageId = PackageService.getStandardPackageId();
    existingFulfillment.packageTypeId = get(existingFulfillment, 'packages.0.packageTypeId', standardPackageId);
    return [existingFulfillment];
  }

  const fulfillmentPlanId = Global.selectOrderDetailsFulfillmentPlanId(state);
  const fulfillmentsFromFulfillmentPlan =
    fulfillmentPlanId &&
    Global.selectEntitiesFulfillmentsByFulfillmentPlanId(state, {
      fulfillmentPlanId,
    });
  return (fulfillmentPlanId ? fulfillmentsFromFulfillmentPlan : fulfillmentsFromSalesOrder).filter(
    (fulfillment) => !fulfillment.isLabelVoided,
  );
};

export const getInitialReturnPackageShippingConfiguration = (state) => {
  const salesOrderId = Global.selectOrderDetailsSalesOrderId(state);
  const fulfillmentIdsFromSalesOrder =
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'fulfillmentIds',
    }) || emptyArray;
  const fulfillmentsFromSalesOrder =
    Global.selectEntitiesFulfillmentsByIds(state, {
      fulfillmentIds: fulfillmentIdsFromSalesOrder,
    }) || emptyArray;
  const nonVoidedFulfillments = calculateNonVoidedFulfillments(state, fulfillmentsFromSalesOrder);

  const outboundPackageTypeId = nonVoidedFulfillments.length !== 1 ? '' : get(nonVoidedFulfillments, '0.packageTypeId');
  const returnPackageArray =
    Global.selectSellerSellerSetting(state, {
      settingName: 'ReturnPackage',
    })?.split('-') || emptyArray;
  const returnServiceFromSettings = Global.selectSellerSellerSetting(state, {
    settingName: 'ReturnService',
  });
  const returnService = returnServiceFromSettings || nonVoidedFulfillments[0]?.serviceId;
  const packageTypeId = returnPackageArray[0] || outboundPackageTypeId;
  const fulfillmentPlanIds =
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'fulfillmentPlanIds',
    }) || emptyArray;
  const fulfillmentPlans = Global.selectEntitiesFulfillmentPlansByIds(state, { fulfillmentPlanIds }) || [];
  const weight = calculateReturnShipmentWeight({
    selectedReturnItems: Global.selectOrderDetailsSelectedReturnItems(state) || [],
    sellerDefaultWeightUnit: Global.selectSellerDefaultWeightUnit(state),
    fulfillmentPlans,
    fulfillments: fulfillmentsFromSalesOrder,
  });
  if (!packageTypeId) {
    return [
      {
        weight,
      },
    ];
  }

  const carriers = Global.selectReferenceDatagetSellerCarriers(state);
  const services = Global.selectSellerServices(state);
  const storePackages = Global.selectSellerPackages(state);
  const packages = PackageService.getPackages(carriers, services, storePackages, true, returnService);
  const matchingPackage = packages.find((p) => p.packageTypeId === packageTypeId) || emptyObject;
  const { value } = matchingPackage;

  return [
    {
      packageId: value,
      packageTypeId,
      weight,
    },
  ];
};
